module.exports = __webpack_public_path__ + "5abc0df152cab5ea38bdb3abc5a42ad1.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/pt.json
// module id = 1159
// module chunks = 0